import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Button, Modal, Form, Offcanvas } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import { useAuth } from '../../../context/AuthContext';
import withPermission from '../../../utils/withPermission';
import Swal from 'sweetalert2';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const API_URL = `${backendUrl}/api/leave-entitlements`;

const LeaveEntitlement = () => {
    const [leave, setleave] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({ name: '' });
    const [isEdit, setIsEdit] = useState(false);
    const [selectedleave, setSelectedleave] = useState(null);
    const didFetchRef = useRef(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const WithListPermission = withPermission(({ children }) => children, ['leave-list']);
    const WithCreatePermission = withPermission(({ children }) => children, ['leave-create']);
    const WithDeletePermission = withPermission(({ children }) => children, ['leave-delete']);
    const WithEditPermission = withPermission(({ children }) => children, ['leave-edit']);
    const [searchQuery, setSearchQuery] = useState('');
    const [errors, setErrors] = useState({});
    const [employees, setEmployees] = useState([]);
    const [leaveTypes, setLeaveTypes] = useState([]);
    const debounceTimeoutRef = useRef(null);
    useEffect(() => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            fetchleave(1, searchQuery);
        }, searchQuery ? 1500 : 0);

        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, [searchQuery]);
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);

    };

    const fetchleave = async (page = 1) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;
            const response = await axios.get(`${API_URL}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params: {
                    page,
                    search: searchQuery,
                },
            });
            setleave(response.data?.data?.data || []);
            setPageCount(response.data.last_page);
            setCurrentPage(response.data.current_page);


        } catch (error) {
            console.error('Error fetching leave:', error);
        }
    };

    const fetchEmployees = async () => {
        const backendUrl = process.env.REACT_APP_BACKEND_URL;

        const userInfo = JSON.parse(localStorage.getItem("user-info"));
        const origin = localStorage.getItem("user-origin");
        const token = userInfo?.token;

        const res = await axios.get(`${backendUrl}/api/employee`, {
            headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin },
            skipLoader: true,
        });
        setEmployees(res.data?.data || []);
    };

    const fetchLeaveTypes = async () => {
        const backendUrl = process.env.REACT_APP_BACKEND_URL;

        const userInfo = JSON.parse(localStorage.getItem("user-info"));
        const origin = localStorage.getItem("user-origin");
        const token = userInfo?.token;

        const res = await axios.get(`${backendUrl}/api/leave-types`, {
            headers: { Authorization: `Bearer ${token}`, "Tenant-Origin": origin },
            skipLoader: true,
        });
        setLeaveTypes(res.data?.data || []);
    };
    useEffect(() => {
        if (showModal) {
            fetchEmployees();
            fetchLeaveTypes();
        }
    }, [showModal]);


    const handleAddleave = () => {
        setFormData({ employee_id: '', leave_type_id: '', max_days: '', carry_forward: false,max_forward_days: '' });
        setIsEdit(false);
        setSelectedleave(null);
        setShowModal(true);
    };

    const handleEditleave = (leave) => {
        setFormData(leave);
        setIsEdit(true);
        setSelectedleave(leave);
        setShowModal(true);
    };

    const handleDelete = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');
                    const token = userInfo?.token;
                    await axios.delete(`${API_URL}/${id}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        },
                    });
                    setleave(leave.filter(leave => leave.id !== id));
                    Swal.fire(
                        "Deleted!",
                        "The leave has been deleted.",
                        "success"
                    );
                } catch (error) {
                    console.error('Error deleting leave:', error);
                    Swal.fire(
                        "Error!",
                        "Failed to delete leave. Please try again.",
                        "error"
                    );
                }
            }
        });

    };

    const handleInputChange = (e) => {
        const { name, type, value, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
        setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    };


    const handlePageChange = ({ selected }) => {
        const newPage = selected + 1;
        setCurrentPage(newPage);
        fetchleave(newPage);
    };
    useEffect(() => {
        if (!showModal) {
            setErrors({});
        }
    }, [showModal]);

    const validateForm = () => {
        const newErrors = {};

        if (!formData.employee_id) {
            newErrors.employee_id = "Employee is required";
        }

        if (!formData.leave_type_id) {
            newErrors.leave_type_id = "Leave type is required";
        }

        if (!formData.max_days || formData.max_days <= 0) {
            newErrors.max_days = "Max days must be greater than 0";
        }

        return newErrors;
    };


    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        const userInfo = JSON.parse(localStorage.getItem('user-info'));
        const origin = localStorage.getItem('user-origin');
        const token = userInfo?.token;
        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setLoading(false);
            return; // Stop here if validation fails
        }
        try {
            if (isEdit) {
                const response = await axios.put(`${API_URL}/${selectedleave.id}`, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                });
                setleave(leave.map(ind => (ind.id === selectedleave.id ? response.data.data : ind)));
            } else {
                const response = await axios.post(API_URL, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                });
                setleave([...leave, response.data.data]);
            }
            setShowModal(false);
        } catch (error) {
            console.error('Error saving leave:', error);
        }
    };

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid ">
                    <div className="row w-100">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">Leave Define</h4>
                                <div className="page-title-right">

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between mb-3">
                                        <div className="d-flex">
                                            <div className="search-box me-2 mb-2 d-inline-block">
                                                <div className="position-relative">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search..."
                                                        value={searchQuery}
                                                        onChange={handleSearchChange}
                                                    />
                                                    <i className="bx bx-search-alt search-icon" />
                                                </div>
                                            </div>



                                        </div>
                                        <WithCreatePermission>
                                            <button
                                                type="button"
                                                className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"

                                                onClick={handleAddleave}
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title='Add leave'
                                            >
                                                <i className="mdi mdi-plus" ></i>
                                            </button></WithCreatePermission>
                                    </div>
                                    <table className="table align-middle table-nowrap table-check table-list">

                                        <thead className="table-light">
                                            <tr>
                                                <th style={{ width: '20px' }} className="align-middle">
                                                    <div className="form-check font-size-16">
                                                        <input className="form-check-input" type="checkbox" id="checkAll" />
                                                        <label className="form-check-label" htmlFor="checkAll"></label>
                                                    </div>
                                                </th>
                                                <th className="align-middle">#</th>
                                                <th className="align-middle"> Employee</th>
                                                <th className="align-middle"> Leave Type</th>
                                                <th className="align-middle"> Max Days</th>
                                                <th className="align-middle"> Carry Forward</th>
                                                <th className="align-middle">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {leave.map((leave, index) => (
                                                <tr key={leave.id}>
                                                    <td>
                                                        <div className="form-check font-size-16">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                id={`instanceCheck${index}`}
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor={`instanceCheck${index}`}
                                                            ></label>
                                                        </div>
                                                    </td>
                                                    <td>{index + 1}</td>
                                                    <td>{leave.employee?.first_name}</td>
                                                    <td>{leave.leave_type?.name}</td>
                                                    <td>{leave.max_days}</td>
                                                    <td>{leave.carry_forward ? 'Yes' : 'No'}</td>
                                                    <td>
                                                        <div className="dropdown">
                                                            <i
                                                                className="mdi mdi-dots-horizontal font-size-18"
                                                                data-bs-toggle="dropdown"
                                                                aria-expanded="false"
                                                                style={{ cursor: 'pointer' }}
                                                            ></i>
                                                            <ul className="dropdown-menu dropdown-menu-end font-size-14">
                                                                <li>
                                                                    <WithEditPermission>
                                                                        <button className="dropdown-item" onClick={() => handleEditleave(leave)}>
                                                                            Edit
                                                                        </button>
                                                                    </WithEditPermission>
                                                                </li>
                                                                <li>
                                                                    <WithDeletePermission>
                                                                        <button className="dropdown-item" onClick={() => handleDelete(leave.id)}>
                                                                            Delete
                                                                        </button>
                                                                    </WithDeletePermission>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div className="d-flex justify-content-end pagination-sm">
                                        <ReactPaginate
                                            previousLabel={'<'}
                                            nextLabel={'>'}
                                            breakLabel={'...'}
                                            pageCount={pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={3}
                                            onPageChange={handlePageChange}
                                            containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                                            pageClassName={'page-item'}
                                            pageLinkClassName={'page-link'}
                                            previousClassName={'page-item previous'}
                                            previousLinkClassName={'page-link'}
                                            nextClassName={'page-item next'}
                                            nextLinkClassName={'page-link'}
                                            breakClassName={'page-item'}
                                            breakLinkClassName={'page-link'}
                                            activeClassName={'active'}
                                        />
                                    </div>
                                    {/* Modal for Add/Edit leave */}
                                    <Offcanvas show={showModal} onHide={() => setShowModal(false)} placement='end' style={{width:'480px'}}>
                                        <Offcanvas.Header closeButton>
                                            <Offcanvas.Title>{isEdit ? 'Edit ' : 'Add'}</Offcanvas.Title>
                                        </Offcanvas.Header>
                                        <hr style={{ margin: 0 }} /><br />

                                        <Offcanvas.Body>
                                            <Form>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Employee</Form.Label>
                                                    <Form.Select name="employee_id" value={formData.employee_id} onChange={handleInputChange}>
                                                        <option value="">Select Employee</option>
                                                        {employees.map(emp => (
                                                            <option key={emp.id} value={emp.id}>
                                                                {emp.first_name} {emp.last_name}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                    {errors.employee_id && <div className="text-danger">{errors.employee_id}</div>}
                                                </Form.Group>

                                                <Form.Group className="mb-3">
                                                    <Form.Label>Leave Type</Form.Label>
                                                    <Form.Select name="leave_type_id" value={formData.leave_type_id} onChange={handleInputChange}>
                                                        <option value="">Select Leave Type</option>
                                                        {leaveTypes.map(lt => (
                                                            <option key={lt.id} value={lt.id}>{lt.name}</option>
                                                        ))}
                                                    </Form.Select>
                                                    {errors.leave_type_id && <div className="text-danger">{errors.leave_type_id}</div>}
                                                </Form.Group>

                                                <Form.Group className="mb-3">
                                                    <Form.Label>Max Days</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        name="max_days"
                                                        value={formData.max_days}
                                                        onChange={handleInputChange}
                                                    />
                                                    {errors.max_days && <div className="text-danger">{errors.max_days}</div>}
                                                </Form.Group>

                                                <Form.Group className="mb-3">
                                                    <Form.Check
                                                        type="checkbox"
                                                        label="Carry Forward"
                                                        name="carry_forward"
                                                        checked={formData.carry_forward}
                                                        onChange={handleInputChange}
                                                    />
                                                </Form.Group>
                                                {formData.carry_forward && (
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Max Forward Days</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            name="max_forward_days"
                                                            value={formData.max_forward_days || ""}
                                                            onChange={handleInputChange}
                                                        />
                                                        {errors.max_forward_days && <div className="text-danger">{errors.max_forward_days}</div>}
                                                    </Form.Group>
                                                )}

                                            </Form>
                                        </Offcanvas.Body>
                                        <div className="p-3 d-flex justify-content-end border-top">
                                            <Button variant="secondary me-2" onClick={() => setShowModal(false)}>Close</Button>
                                            <Button variant="primary" onClick={handleSubmit}>{isEdit ? 'Update' : 'Save'} </Button>
                                        </div>
                                    </Offcanvas>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LeaveEntitlement;
